import React from 'react';
import { ABOUT_PAGE } from '../mock';
import Reveal from './Reveal';

const Journey = () => {
  const { journey } = ABOUT_PAGE;
  return (
    <section className="bg-[#faf7f0] py-16 md:py-20">
      <div className="mx-auto max-w-5xl px-6 text-center md:px-10">
        {/* Text */}
        <div>
          <Reveal>
            <p className="mb-6 text-[10px] uppercase tracking-[0.5em] text-gold-dark">
              {journey.label}
            </p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-4xl font-light leading-tight tracking-[0.03em] text-ink md:text-5xl">
              From Ambition
              <br />
              to Impact
            </h2>
          </Reveal>
          <Reveal delay={220}>
            <div className="mx-auto mt-6 h-px w-12 bg-gold" />
          </Reveal>
          <Reveal delay={300}>
            <div className="mx-auto mt-8 max-w-3xl space-y-5">
              {journey.paragraphs.map((p) => (
                <p key={p} className="text-base leading-relaxed text-ink/70">
                  {p}
                </p>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Journey;
